import { RestApiSenderConfig } from 'ihub/common';
import { AdvancedTourStep } from '../../shared-types';
import { RestApiSenderTourProps } from './rest-api-sender-tour-props';

export function getRestApiSenderQueryParameterSteps({
	defaultStyles,
	microTaskConfigType,
}: Readonly<RestApiSenderTourProps>): AdvancedTourStep[] {
	if (!microTaskConfigType) return [];
	const config = microTaskConfigType as RestApiSenderConfig;

	return [
		{
			id: 'query-add-key-value',
			selector: '[data-tour="query-add-key-value"]',
			content: 'Add an additional query parameter property to the request.',
		},
		...(config.additionalQueryParams
			? [
					{
						id: 'query-dictionary-item-key',
						selector: '[data-tour="query-dictionary-item-key"]',
						content: 'The key value to assign to the new query parameter',
					},
					{
						id: 'query-dictionary-item-value',
						selector: '[data-tour="query-dictionary-item-value"]',
						content: 'The value that will be assigned to the query parameter.',
					},
					{
						id: 'query-delete-dictionary-item',
						selector: '[data-tour="query-dictionary-item-delete"]',
						content: 'Removes the query parameter row and all of its config',
					},
				]
			: []),
	].map(tourItem => ({ ...tourItem, styles: defaultStyles }));
}
